import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { userAPI } from '../services/api';
import './Questionnaire.css';

const tennisQuestions = [
  {
    id: 1,
    question: 'How often do you play tennis?',
    options: [
      { label: 'Never / Just starting', value: 0 },
      { label: 'Once a month', value: 3 },
      { label: '2-3 times per month', value: 5 },
      { label: 'Once a week', value: 7 },
      { label: 'Multiple times per week', value: 10 },
    ],
  },
  {
    id: 2,
    question: 'How many years have you been playing?',
    options: [
      { label: 'Less than 1 year', value: 0 },
      { label: '1-2 years', value: 3 },
      { label: '3-5 years', value: 6 },
      { label: '6-10 years', value: 8 },
      { label: 'More than 10 years', value: 10 },
    ],
  },
  {
    id: 3,
    question: 'Rate your serve consistency',
    options: [
      { label: 'Very inconsistent', value: 0 },
      { label: 'Sometimes lands in', value: 3 },
      { label: 'Usually lands in', value: 6 },
      { label: 'Consistently lands in', value: 8 },
      { label: 'Very consistent', value: 10 },
    ],
  },
  {
    id: 4,
    question: 'Rate your forehand',
    options: [
      { label: 'Beginner', value: 0 },
      { label: 'Developing', value: 3 },
      { label: 'Solid', value: 6 },
      { label: 'Advanced', value: 10 },
    ],
  },
  {
    id: 5,
    question: 'Rate your backhand',
    options: [
      { label: 'Beginner', value: 0 },
      { label: 'Developing', value: 3 },
      { label: 'Solid', value: 6 },
      { label: 'Advanced', value: 10 },
    ],
  },
  {
    id: 6,
    question: 'Can you play volleys at the net?',
    options: [
      { label: 'No / Rarely', value: 0 },
      { label: 'Sometimes', value: 4 },
      { label: 'Yes, comfortably', value: 6 },
      { label: 'Expert level', value: 10 },
    ],
  },
  {
    id: 7,
    question: 'How is your court movement?',
    options: [
      { label: 'Limited mobility', value: 0 },
      { label: 'Average', value: 5 },
      { label: 'Quick and agile', value: 10 },
    ],
  },
  {
    id: 8,
    question: 'Do you understand tennis strategy and tactics?',
    options: [
      { label: 'Just learning', value: 0 },
      { label: 'Basic understanding', value: 5 },
      { label: 'Strong tactical knowledge', value: 10 },
    ],
  },
  {
    id: 9,
    question: 'Have you competed in tournaments?',
    options: [
      { label: 'No', value: 0 },
      { label: 'Local/club level', value: 5 },
      { label: 'Regional or higher', value: 10 },
    ],
  },
  {
    id: 10,
    question: 'Rate your overall tennis fitness',
    options: [
      { label: 'Need improvement', value: 0 },
      { label: 'Average fitness', value: 5 },
      { label: 'Excellent fitness', value: 10 },
    ],
  },
];

const squashQuestions = [
  {
    id: 1,
    question: 'How often do you play squash?',
    options: [
      { label: 'Never / Just starting', value: 0 },
      { label: 'Once a month', value: 3 },
      { label: '2-3 times per month', value: 5 },
      { label: 'Once a week', value: 7 },
      { label: 'Multiple times per week', value: 10 },
    ],
  },
  {
    id: 2,
    question: 'How many years have you been playing?',
    options: [
      { label: 'Less than 1 year', value: 0 },
      { label: '1-2 years', value: 3 },
      { label: '3-5 years', value: 6 },
      { label: '6-10 years', value: 8 },
      { label: 'More than 10 years', value: 10 },
    ],
  },
  {
    id: 3,
    question: 'Rate your serve consistency',
    options: [
      { label: 'Very inconsistent', value: 0 },
      { label: 'Sometimes lands in', value: 3 },
      { label: 'Usually lands in', value: 6 },
      { label: 'Consistently lands in', value: 8 },
      { label: 'Very consistent', value: 10 },
    ],
  },
  {
    id: 4,
    question: 'Rate your forehand drive',
    options: [
      { label: 'Beginner', value: 0 },
      { label: 'Developing', value: 3 },
      { label: 'Solid', value: 6 },
      { label: 'Advanced', value: 10 },
    ],
  },
  {
    id: 5,
    question: 'Rate your backhand drive',
    options: [
      { label: 'Beginner', value: 0 },
      { label: 'Developing', value: 3 },
      { label: 'Solid', value: 6 },
      { label: 'Advanced', value: 10 },
    ],
  },
  {
    id: 6,
    question: 'Can you play drop shots effectively?',
    options: [
      { label: 'No / Rarely', value: 0 },
      { label: 'Sometimes', value: 4 },
      { label: 'Yes, comfortably', value: 6 },
      { label: 'Expert level', value: 10 },
    ],
  },
  {
    id: 7,
    question: 'How is your court movement and positioning?',
    options: [
      { label: 'Limited mobility', value: 0 },
      { label: 'Average', value: 5 },
      { label: 'Quick and agile', value: 10 },
    ],
  },
  {
    id: 8,
    question: 'Do you understand squash strategy and tactics?',
    options: [
      { label: 'Just learning', value: 0 },
      { label: 'Basic understanding', value: 5 },
      { label: 'Strong tactical knowledge', value: 10 },
    ],
  },
  {
    id: 9,
    question: 'Have you competed in tournaments?',
    options: [
      { label: 'No', value: 0 },
      { label: 'Local/club level', value: 5 },
      { label: 'Regional or higher', value: 10 },
    ],
  },
  {
    id: 10,
    question: 'Rate your overall squash fitness',
    options: [
      { label: 'Need improvement', value: 0 },
      { label: 'Average fitness', value: 5 },
      { label: 'Excellent fitness', value: 10 },
    ],
  },
];

const Questionnaire = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, refreshUser } = useAuth();
  const [answers, setAnswers] = useState(Array(10).fill(null));
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Get sport from URL query params, fallback to user's default sport or default
  const sportFromUrl = searchParams.get('sport');
  const targetSport = sportFromUrl || user?.defaultSport || 'Tennis (singles)';
  
  // Select questions based on sport
  const questions = targetSport === 'Squash' ? squashQuestions : tennisQuestions;

  const handleAnswer = (value) => {
    const newAnswers = [...answers];
    newAnswers[currentQuestion] = value;
    setAnswers(newAnswers);

    // Auto-advance to next question
    if (currentQuestion < questions.length - 1) {
      setTimeout(() => {
        setCurrentQuestion(currentQuestion + 1);
      }, 300);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleSubmit = async () => {
    setError('');
    
    // Check if all questions are answered
    if (answers.includes(null)) {
      setError('Please answer all questions before submitting');
      return;
    }

    setLoading(true);

    try {
      await userAPI.submitQuestionnaire(user.userId, answers, targetSport);
      await refreshUser();
      navigate('/leagues');
    } catch (err) {
      console.error('Submit questionnaire error:', err);
      setError(err.response?.data?.error || 'Failed to submit questionnaire');
    } finally {
      setLoading(false);
    }
  };

  const progress = ((currentQuestion + 1) / questions.length) * 100;
  const allAnswered = !answers.includes(null);

  return (
    <div className="questionnaire-container">
      <div className="questionnaire-card">
        <div className="questionnaire-header">
          <h1>Assess Your {targetSport} Level</h1>
          <p>Answer 10 questions to determine your skill level (0-100)</p>
        </div>

        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>

        <div className="question-counter">
          Question {currentQuestion + 1} of {questions.length}
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="question-section">
          <h2 className="question-text">{questions[currentQuestion].question}</h2>

          <div className="options-list">
            {questions[currentQuestion].options.map((option, index) => (
              <button
                key={index}
                className={`option-button ${
                  answers[currentQuestion] === option.value ? 'selected' : ''
                }`}
                onClick={() => handleAnswer(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        <div className="questionnaire-navigation">
          <button
            onClick={handlePrevious}
            disabled={currentQuestion === 0}
            className="btn btn-secondary"
          >
            Previous
          </button>

          {currentQuestion === questions.length - 1 && allAnswered ? (
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="btn btn-success"
            >
              {loading ? 'Submitting...' : 'Submit & Continue'}
            </button>
          ) : (
            <button
              onClick={() => setCurrentQuestion(Math.min(currentQuestion + 1, questions.length - 1))}
              disabled={currentQuestion === questions.length - 1}
              className="btn btn-primary"
            >
              Next
            </button>
          )}
        </div>

        <div className="answers-summary">
          <p>Answered: {answers.filter(a => a !== null).length} / {questions.length}</p>
        </div>
      </div>
    </div>
  );
};

export default Questionnaire;

